import styled from "styled-components";

export const Participante = styled.li`
    text-align: center;
    color: #444444;
    line-height: 1.5;
    @media screen and (min-width: 1024px) {
        font-size: 1.25rem;
    }

`